(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-promo-ticker]:not([data-initialized])').forEach(band => {
    band.dataset.initialized = 'true';
    const storageKey = 'par4-promotions-dismissed';
    try { if (sessionStorage.getItem(storageKey)) band.hidden = true; } catch {}
    const track = band.querySelector('.promo-ticker__track');
    const group = band.querySelector('.promo-ticker__group');
    const pause = band.querySelector('[data-promo-pause]');
    const duplicate = group.cloneNode(true);
    duplicate.setAttribute('aria-hidden', 'true');
    duplicate.querySelectorAll('a').forEach(link => link.tabIndex = -1);
    track.append(duplicate);
    const measure = () => {
      const width = group.getBoundingClientRect().width;
      band.style.setProperty('--promo-distance', `${width}px`);
      band.style.setProperty('--promo-duration', `${Math.max(40, width / 42)}s`);
      band.dataset.ready = 'true';
    };
    const observer = new ResizeObserver(measure);
    observer.observe(group);
    pause.hidden = false;
    pause.addEventListener('click', () => {
      const paused = band.toggleAttribute('data-paused');
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel);
      pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
    });
    band.querySelector('[data-promo-close]').addEventListener('click', () => {
      band.hidden = true;
      try { sessionStorage.setItem(storageKey, '1'); } catch {}
    });
    measure();
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
